import { useState } from "react";
import { useNavigate } from "react-router/dist";
import { usePropertyInventory } from "../../../../../hooks/usePropertyInventory";
import { Button, Card, CardContent, Chip, Paper, Typography } from "@mui/material";
import { alpha, Box, Grid } from "@mui/system";
import { ArrowBack } from "@mui/icons-material";
import { useAuth } from "../../../../../context/AuthContext";

export const Step5Summary = () => {
  const { currentStep, setCurrentStep, apartments, tenants, apartmentComplex,
    isCreating, errorMessage, createApartmentComplex
  } = usePropertyInventory();
  const [showSuccess, setShowSuccess] = useState(false);
  const { userToken } = useAuth();
  const navigate = useNavigate();

  const user = userToken?.user.profiles.find(p => p.roleId === 4);

  const handlePrevious = () => {
    setCurrentStep(currentStep - 1);
  };

  const handleSubmit = async () => {
    if (apartmentComplex && user) {
      apartmentComplex.ownerId = user?.id;
      await createApartmentComplex(apartmentComplex!);
      if (!errorMessage) {
        setShowSuccess(true);
        localStorage.removeItem("selectedApartmentComplexId");
        localStorage.removeItem("createApartmentComplex");
      }
    }
  };

  // Calcular estadísticas
  // const totalApartments = apartments?.length;
  // const availableApartments = apartments?.filter(apt => apt.apartmentStatus === 1).length;
  // const occupiedApartments = apartments?.filter(apt => apt.apartmentStatus === 2).length;
  // const maintenanceApartments = apartments?.filter(apt => apt.apartmentStatus === 3).length;
  const totalTenants = Object.keys(tenants || {}).length;

  // Calcular ingresos estimados
  //  const totalIncome = apartments?.reduce((sum: number, apt : any) => {
  //    if (apt.apartmentStatus === 2 && apt.basementRent) {
  //      return sum + parseFloat(apt.basementRent || 0);
  //    }
  //    return sum;
  //  }, 0);

  if (showSuccess) {
    return (
      <Card sx={{ mb: 4 }}>
        <CardContent sx={{ p: 6, textAlign: 'center' }}>
          <Box sx={{
            p: 4,
            backgroundColor: alpha('#4CAF50', 0.1),
            borderRadius: 3,
            mb: 4
          }}>
            <Typography sx={{ fontSize: '4rem', mb: 2 }}>✅</Typography>
            <Typography variant="h4" fontWeight="bold" color="#388E3C" sx={{ mb: 2 }}>
              ¡Propiedad Creada Exitosamente!
            </Typography>
            <Typography variant="h6" color="text.secondary">
              {apartmentComplex?.name} ha sido agregado a tu portafolio
            </Typography>
          </Box>

          <Button
            variant="contained"
            size="large"
            onClick={() => navigate('/properties-inventory/')}
            sx={{
              backgroundColor: '#4DB6AC',
              px: 4,
              py: 2,
              '&:hover': {
                backgroundColor: '#26A69A',
              }
            }}
          >
            Ver en página principal
          </Button>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card sx={{ mb: 4 }}>
      <CardContent sx={{ p: 4 }}>
        <Typography variant="h5" fontWeight="bold" color="#2E7D7A" sx={{ mb: 3 }}>
          Resumen Final
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          Revisa toda la información antes de crear la propiedad
        </Typography>

        <Grid container spacing={4}>
          {/* Resumen del Complejo */}
          <Grid size={{ xs: 12, md: 6 }}>
            <Card sx={{ p: 3, backgroundColor: '#FAFAFA', height: '100%' }}>
              <Typography variant="h6" fontWeight="bold" sx={{ mb: 3, color: '#2E7D7A' }}>
                Información del Complejo
              </Typography>

              <Box sx={{ mb: 2 }}>
                <Typography variant="body2" color="text.secondary">Nombre</Typography>
                <Typography variant="body1" fontWeight="bold">
                  {apartmentComplex?.name || 'Sin nombre'}
                </Typography>
              </Box>

              <Box sx={{ mb: 2 }}>
                <Typography variant="body2" color="text.secondary">Ubicación</Typography>
                <Typography variant="body1">
                  {apartmentComplex?.location || 'Sin ubicación'}
                </Typography>
              </Box>

              <Box sx={{ mb: 2 }}>
                <Typography variant="body2" color="text.secondary">Dimensiones</Typography>
                <Typography variant="body1">
                  {apartmentComplex?.squareMeters || 'No especificado'}
                </Typography>
              </Box>

              <Box sx={{ mb: 2 }}>
                <Typography variant="body2" color="text.secondary">Descripción</Typography>
                <Typography variant="body1" sx={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: '-webkit-box',
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: 'vertical'
                }}>
                  {apartmentComplex?.description || 'Sin descripción'}
                </Typography>
              </Box>
            </Card>
          </Grid>

          {/* Estadísticas Rápidas */}
          {/* <Grid size={{ xs: 12, md: 6 }}>
           <Card sx={{ p: 3, backgroundColor: '#FAFAFA', height: '100%' }}>
             <Typography variant="h6" fontWeight="bold" sx={{ mb: 3, color: '#2E7D7A' }}>
               Estadísticas del Complejo
             </Typography>

             <Grid container spacing={2}>
               <Grid size={{ xs: 6 }}>
                 <Box sx={{ textAlign: 'center', p: 2, backgroundColor: 'white', borderRadius: 2 }}>
                   <Typography variant="h4" fontWeight="bold" color="#2196F3">
                     {totalApartments}
                   </Typography>
                   <Typography variant="caption" color="text.secondary">
                     Total Apartamentos
                   </Typography>
                 </Box>
               </Grid>
               <Grid size={{ xs: 6 }}>
                 <Box sx={{ textAlign: 'center', p: 2, backgroundColor: 'white', borderRadius: 2 }}>
                   <Typography variant="h4" fontWeight="bold" color="#4CAF50">
                     {availableApartments}
                   </Typography>
                   <Typography variant="caption" color="text.secondary">
                     Disponibles
                   </Typography>
                 </Box>
               </Grid>
               <Grid size={{ xs: 6 }}>
                 <Box sx={{ textAlign: 'center', p: 2, backgroundColor: 'white', borderRadius: 2 }}>
                   <Typography variant="h4" fontWeight="bold" color="#FF9800">
                     {occupiedApartments}
                   </Typography>
                   <Typography variant="caption" color="text.secondary">
                     Ocupados
                   </Typography>
                 </Box>
               </Grid>
               <Grid size={{ xs: 6 }}>
                 <Box sx={{ textAlign: 'center', p: 2, backgroundColor: 'white', borderRadius: 2 }}>
                   <Typography variant="h4" fontWeight="bold" color="#F44336">
                     {maintenanceApartments}
                   </Typography>
                   <Typography variant="caption" color="text.secondary">
                     Mantenimiento
                   </Typography>
                 </Box>
               </Grid>
             </Grid>

             {totalIncome && totalIncome > 0 && (
               <Box sx={{ 
                 mt: 3, 
                 p: 2, 
                 backgroundColor: alpha('#4CAF50', 0.1), 
                 borderRadius: 2,
                 textAlign: 'center'
               }}>
                 <Typography variant="body2" color="text.secondary">
                   Ingresos Mensuales Estimados
                 </Typography>
                 <Typography variant="h5" fontWeight="bold" color="#388E3C">
                   ₡{totalIncome.toLocaleString()}
                 </Typography>
               </Box>
             )}
           </Card>
         </Grid> */}
        </Grid>

        {/* Detalle de Apartamentos */}
        {/* <Card sx={{ p: 3, backgroundColor: '#FAFAFA', mt: 4 }}>
         <Typography variant="h6" fontWeight="bold" sx={{ mb: 3, color: '#2E7D7A' }}>
           Detalle de Apartamentos ({totalApartments})
         </Typography>

         <Grid container spacing={2}>
           {apartments?.map((apartment: any) => (
             <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }} key={apartment.id}>
               <Paper sx={{ 
                 p: 2, 
                 border: '2px solid',
                 borderColor: apartment.status === 'available' ? '#4CAF50' : 
                             apartment.status === 'occupied' ? '#FF9800' : '#F44336'
               }}>
                 <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                   <Home sx={{ 
                     color: apartment.status === 'available' ? '#4CAF50' : 
                            apartment.status === 'occupied' ? '#FF9800' : '#F44336',
                     mr: 1 
                   }} />
                   <Typography variant="subtitle1" fontWeight="bold">
                     Apto {apartment.number}
                   </Typography>
                 </Box>
                 
                 <Typography variant="caption" color="text.secondary">
                   {apartment.type || 'Sin tipo'}
                 </Typography>
                 
                 {apartment.monthlyPrice && (
                   <Typography variant="body2" fontWeight="bold" color="#2E7D7A">
                     {apartment.currency === 'CRC' ? '₡' : 
                      apartment.currency === 'USD' ? '$' : '€'}
                     {parseFloat(apartment.monthlyPrice).toLocaleString()}
                   </Typography>
                 )}

                 <Chip 
                   label={apartment.status === 'available' ? 'Disponible' : 
                          apartment.status === 'occupied' ? 'Ocupado' : 'Mantenimiento'}
                   size="small"
                   sx={{ 
                     mt: 1,
                     backgroundColor: alpha(
                       apartment.status === 'available' ? '#4CAF50' : 
                       apartment.status === 'occupied' ? '#FF9800' : '#F44336', 
                       0.1
                     ),
                     color: apartment.status === 'available' ? '#388E3C' : 
                            apartment.status === 'occupied' ? '#F57C00' : '#D32F2F'
                   }}
                 />
               </Paper>
             </Grid>
           ))}
         </Grid>
       </Card> */}

        {/* Inquilinos */}
        {totalTenants > 0 && (
          <Card sx={{ p: 3, backgroundColor: '#FAFAFA', mt: 4 }}>
            <Typography variant="h6" fontWeight="bold" sx={{ mb: 3, color: '#2E7D7A' }}>
              Inquilinos Registrados ({totalTenants})
            </Typography>

            <Grid container spacing={3}>
              {Object.entries(tenants || {}).map(([apartmentId, tenant]) => {
                const apartment = apartments?.find(apt => apt.apartmentNumber === apartmentId);
                const t = tenant as {
                  name?: string;
                  phone?: string;
                  email?: string;
                  profession?: string;
                  entryDate?: string;
                };
                return (
                  <Grid size={{ xs: 12, md: 6 }} key={apartmentId}>
                    <Paper sx={{ p: 2, border: '1px solid #E0E0E0' }}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Typography variant="subtitle1" fontWeight="bold">
                          {t.name || 'Sin nombre'}
                        </Typography>
                        <Chip
                          label={`Apto ${apartment?.apartmentNumber}`}
                          size="small"
                          sx={{ backgroundColor: alpha('#FF9800', 0.1), color: '#F57C00' }}
                        />
                      </Box>

                      <Typography variant="body2" color="text.secondary">
                        📞 {t.phone || 'Sin teléfono'}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        ✉️ {t.email || 'Sin email'}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        💼 {t.profession || 'Sin profesión'}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        📅 Ingreso: {t.entryDate || 'Sin fecha'}
                      </Typography>
                    </Paper>
                  </Grid>
                );
              })}
            </Grid>
          </Card>
        )}

        {/* Botones de navegación */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 6 }}>
          <Button
            variant="outlined"
            startIcon={<ArrowBack />}
            onClick={handlePrevious}
            disabled={isCreating}
            sx={{
              borderColor: '#4DB6AC',
              color: '#4DB6AC',
              '&:hover': {
                borderColor: '#26A69A',
                backgroundColor: alpha('#4DB6AC', 0.1)
              }
            }}
          >
            Anterior
          </Button>

          <Button
            variant="contained"
            size="large"
            onClick={handleSubmit}
            disabled={isCreating}
            sx={{
              backgroundColor: '#4DB6AC',
              px: 4,
              py: 1.5,
              '&:hover': {
                backgroundColor: '#26A69A',
              },
              '&:disabled': {
                backgroundColor: '#E0E0E0',
              }
            }}
          >
            {isCreating ? (
              <>
                <Box sx={{
                  width: 20,
                  height: 20,
                  border: '2px solid #fff',
                  borderTop: '2px solid transparent',
                  borderRadius: '50%',
                  animation: 'spin 1s linear infinite',
                  mr: 1,
                  '@keyframes spin': {
                    '0%': { transform: 'rotate(0deg)' },
                    '100%': { transform: 'rotate(360deg)' }
                  }
                }} />
                Creando Propiedad...
              </>
            ) : (
              'Crear Propiedad'
            )}
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};